import "./GasOvenMaintenanceRiyadh.module.css";
import Header from "@/reusable_sections/Header";
import GasOvenHero from "./sections/GasOvenHero";
import GasOvenMaintenanceService from "./sections/GasOvenMaintenanceService";
import Footer from "@/reusable_sections/Footer";
export default function GasOvenMaintenanceRiyadhPage() {
  return <div>
      <Header />
      <GasOvenHero />
      <GasOvenMaintenanceService />
      <Footer />
    </div>;
}